import ReactJson from 'react-json-view';
import { isPlainObject } from 'es-toolkit';

interface JSONSchemaProps {
    value: unknown;
}

const JSONSchema = ({ value }: JSONSchemaProps) => {
    let json: unknown;
    let isValid = true;

    if (typeof value === 'string') {
        try {
            json = JSON.parse(value);
        } catch {
            isValid = false;
        }
    } else if (isPlainObject(value)) {
        json = value;
    } else {
        isValid = false;
    }

    if (!isValid) {
        return (
            <div className="text-xs text-red-6 text-center py-6">
                Schema is not a valid JSON
            </div>
        );
    }

    return (
        <ReactJson
            displayDataTypes={false}
            displayObjectSize={false}
            name={false}
            src={json as object}
            style={{
                fontSize: '12px'
            }}
        />
    );
};

export default JSONSchema;
